export default function isIterable(object) {
  return object != null && typeof object[Symbol.iterator] === 'function';
}
